// 分类配置常量
export const CATEGORY_CONFIGS = [
  {
    value: 0,
    label: 'AI分析 (AI Analytics)',
    category: 'ai-analytics' as const,
    icon: '🤖',
    color: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
    subcategories: [
      {
        title: 'AI运营分析',
        subtitle: 'AI Operations Analysis',
        icon: '🤖',
        color: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
      }
    ]
  },
  {
    value: 1,
    label: '获客 (Acquisition)',
    category: 'acquisition' as const,
    icon: '🌍',
    color: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
    subcategories: [
      {
        title: '用户获取分析',
        subtitle: 'Acquisition Analysis',
        icon: '🌍',
        color: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
      }
    ]
  },
  {
    value: 2,
    label: '激活 (Activation)',
    category: 'activation' as const,
    icon: '🚀',
    color: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
    subcategories: [
      {
        title: '首次存款指标',
        subtitle: 'First Deposit Metrics',
        icon: '🚀',
        color: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
      },
      {
        title: '首次交易激活',
        subtitle: 'First Trade Activation',
        icon: '⚡',
        color: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
      }
    ]
  },
  {
    value: 3,
    label: '留存 (Retention)',
    category: 'retention' as const,
    icon: '🔄',
    color: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
    subcategories: [
      {
        title: '客户活跃度',
        subtitle: 'Customer Activity',
        icon: '🔄',
        color: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
      },
      {
        title: '资金流动指标',
        subtitle: 'Capital Flow Metrics',
        icon: '💰',
        color: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
      },
      {
        title: '提取行为分析',
        subtitle: 'Withdrawal Behavior',
        icon: '📤',
        color: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
      }
    ]
  },
  {
    value: 4,
    label: '收入 (Revenue)',
    category: 'revenue' as const,
    icon: '📈',
    color: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
    subcategories: [
      {
        title: '收入指标',
        subtitle: 'Revenue Metrics',
        icon: '📈',
        color: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
      },
      {
        title: '收入来源分析',
        subtitle: 'Revenue Sources',
        icon: '💼',
        color: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
      }
         ]
   }
 ];

// Grid布局配置
export const GRID_CONFIGS = {
  AI_ANALYTICS: {
    containerProps: { spacing: 4, justifyContent: "center" },
    itemProps: { xs: 12, lg: 8 }
  },
  ACQUISITION: {
    containerProps: { spacing: 4, justifyContent: "center" },
    itemProps: { xs: 12, lg: 8 }
  },
  ACTIVATION: {
    containerProps: { spacing: 4 },
    itemProps: { xs: 12, lg: 6 }
  },
  RETENTION: {
    containerProps: { spacing: 4 },
    itemProps: { xs: 12, lg: 4 }
  },
  REVENUE: {
    containerProps: { spacing: 4 },
    itemProps: { xs: 12, lg: 6 }
  },
  DEFAULT: {
    containerProps: { spacing: 4 },
    itemProps: { xs: 12, lg: 6 }
  }
};

// 主题配置
export const THEME_CONFIG = {
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#10b981',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
    text: {
      primary: '#1a202c',
      secondary: '#4a5568',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Microsoft YaHei", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 300,
      letterSpacing: '0.15em',
    },
    h2: {
      fontWeight: 400,
      letterSpacing: '0.1em',
    },
    h3: {
      fontWeight: 500,
      letterSpacing: '0.05em',
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none' as const,
          fontWeight: 500,
          padding: '8px 16px',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none' as const,
          fontWeight: 500,
          fontSize: '1rem',
        },
      },
    },
  },
};

// 动画配置
export const ANIMATION_CONFIG = {
  FADE: {
    TIMEOUT: 800,
    IN: true
  },
  ZOOM: {
    TIMEOUT: 1500,
    IN: true
  },
  PARTICLE: {
    COUNT: 25,
    MIN_SIZE: 2,
    MAX_SIZE: 6,
    MIN_DURATION: 4,
    MAX_DURATION: 10,
    MAX_DELAY: 3
  }
};

// 通知配置
export const NOTIFICATION_CONFIG = {
  AUTO_HIDE_DURATION: 6000,
  ANCHOR_ORIGIN: { 
    vertical: 'bottom' as const, 
    horizontal: 'center' as const 
  }
};

// 模态框配置
export const MODAL_CONFIG = {
  MAX_WIDTH: 'md',
  FULL_WIDTH: true,
  TRANSITION_DURATION: 300
};

// 加载配置
export const LOADING_CONFIG = {
  BACKDROP_COLOR: '#fff',
  CIRCULAR_SIZE: 40,
  Z_INDEX: (theme: any) => theme.zIndex.drawer + 1
};

// 响应式断点配置
export const BREAKPOINT_CONFIG = {
  MOBILE: 'md',
  TABLET: 'lg',
  DESKTOP: 'xl'
};

// 间距配置
export const SPACING_CONFIG = {
  HEADER_PADDING: 8,
  CONTENT_PADDING: 4,
  CARD_PADDING: 3,
  STATUS_GAP: 3,
  STATUS_ITEM_GAP: 1,
  GRID_SPACING: 4
};

// 颜色配置
export const COLOR_CONFIG = {
  GRADIENTS: {
    PRIMARY: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
    SUCCESS: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
    WARNING: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
    INFO: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
    AI: 'linear-gradient(135deg, #059669 0%, #10b981 100%)'
  },
  SOLID: {
    PRIMARY: '#00d4aa',
    WHITE: '#ffffff',
    LIGHT_GRAY: '#cccccc',
    BORDER: 'rgba(255, 255, 255, 0.1)',
    SUCCESS: '#10b981',
    WARNING: '#ef4444',
    INFO: '#3b82f6'
  }
};

// 字体配置
export const FONT_CONFIG = {
  MONO: '"Roboto Mono", "Courier New", monospace',
  SANS: '"Roboto", "Helvetica", sans-serif',
  SIZES: {
    SMALL: '0.9rem',
    NORMAL: '1rem',
    LARGE: '1.1rem',
    XLARGE: '1.2rem'
  },
  WEIGHTS: {
    LIGHT: 300,
    NORMAL: 400,
    MEDIUM: 500,
    BOLD: 700
  }
}; 